import { Route, Routes } from "react-router-dom";
import ContractorList from "../../newComponents/contractor/ContractorList";
import ContractorDetail from "../../newComponents/contractor/ContractorDetail";
import { PermissionGuard } from "../../newComponents/PermissionGuard";
import { AccessLevelEnum } from "@propertelligent/client-api";
import NoAccess from "../NoAccess";

const Contractor = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <PermissionGuard
            permission="Contractor"
            level={AccessLevelEnum.ReadOnly}
            fallback={<NoAccess />}
          >
            <ContractorList />
          </PermissionGuard>
        }
      />
      <Route
        path="/contractor-details/:id"
        element={
          <PermissionGuard
            permission="Contractor"
            level={AccessLevelEnum.ReadOnly}
            fallback={<NoAccess />}
          >
            <ContractorDetail />
          </PermissionGuard>
        }
      />
    </Routes>
  );
};



export default Contractor;